import { useLayoutEffect } from 'react'
import {
  useState,
  useEffect,
  useRef,
  Images,
  useDispatch,
  useSelector,
  setIpoType,
  getIpoList,
  setIpoData,
  clearError,
  setError,
  stopLoading,
  startLoading,
  icons
} from '../utils/npm'
import { setSearchIPO } from '../store/slice/masterSlice'
const { selectIcon } = Images
const { IoCaretDownSharp } = icons

function FilterListingType() {

  const dispatch = useDispatch()
  const selectedType = useSelector(state => state.ipoData.ipotype)
  const selectedCategory = useSelector(state => state.ipoData.ipoCategory)

  // Ensure a default value for dropdownTitle
  const [dropdownTitle, setDropdownTitle] = useState(selectedType || 'All IPOs')
  const [menuShow, setMenuShow] = useState('')
  const dropdownRef = useRef(null)

  const handleFilterClick = async (filterType, filterName) => {
    dispatch(setIpoType(filterType))
    setDropdownTitle(filterName)
    setMenuShow('')

    try {
      dispatch(startLoading())
      dispatch(setSearchIPO(''))
      const data = {
        ipo_type: filterType,
        category: selectedCategory,
        search: ''
      }
      const response = await getIpoList(data)
      if (
        response.meta.status_code === 200 &&
        response.data.results !== undefined
      ) {
        dispatch(setIpoData(response.data.results))
        dispatch(clearError())
      } else {
        dispatch(setIpoData([]))
        dispatch(setError('An error occurred')) // Handle error case
      }
    } catch (error) {
      dispatch(setIpoData([]))
      console.error(error) // Log the actual error for debugging
      dispatch(setError(error.message || 'An error occurred')) // Set the error message
    } finally {
      dispatch(stopLoading()) // Stop loading after the request completes
    }
  }

  const handleMainBoard = () => {
    setMenuShow(menuShow === '' ? 'open_filter' : '') // Toggle menu visibility
  }

  // Close dropdown when clicking outside
  useLayoutEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuShow('') // Close the dropdown
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <li className='nav-item dropdown home-filter-dropdown' ref={dropdownRef}>
      <a
        className='nav-link dropdown-toggle filter-inner-sec'
        role='button'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        onClick={handleMainBoard}
      >
        <img src={selectIcon} alt='Filter' className='filter-icon' style={{ width: '22px', height: '12px' }} />
        <span
          className={`dropdown-title ${dropdownTitle === 'sme' ? 'uppercase' : 'capitalize'
            }`}
        >
          {dropdownTitle}
        </span>
        <span>
          <IoCaretDownSharp className='text-xs down_arrow_filter' />
        </span>
      </a>
      <ul className={`dropdown-menu ${menuShow}`}>
        <li>
          <a
            className={`dropdown-item cursor-pointer ${selectedType === 'mainboard' ? 'active' : ''
              }`}
            onClick={() => handleFilterClick('mainboard', 'MainBoard')}
          >
            MainBoard
          </a>
        </li>
        <li>
          <a
            className={`dropdown-item cursor-pointer ${selectedType === 'sme' ? 'active' : ''
              }`}
            onClick={() => handleFilterClick('sme', 'SME')}
          >
            SME
          </a>
        </li>
        <li>
          <hr className='dropdown-divider' />
        </li>
        <li>
          <a
            className={`dropdown-item cursor-pointer ${selectedType === '' ? 'active' : ''
              }`}
            onClick={() => handleFilterClick('', 'All IPOs')}
          >
            All IPOs
          </a>
        </li>
      </ul>
    </li>
  )
}

export default FilterListingType
